export const BasicData = [
  {
    listText: "Introduction to Product Management",
  },
  {
    listText: "Product Thinking",
  },
  {
    listText: "Understanding Product Life Cycle",
  },
  {
    listText: "Conducting User Research",
  },
  {
    listText: "User Segmentation & Personas",
  },
  {
    listText: "Writing User Stories",
  },
  {
    listText: "Competitive Market Analysis",
  },
  {
    listText: "Minimum Viable Product",
  },
  {
    listText: "Product Terminologies",
  },
  {
    listText: "Certificate of Completion",
  },
];

export const AdvancedData = [
  {
    listText: "Everything in the basic program",
  },
  {
    listText: "Introduction to Product Management",
  },
  {
    listText: "Product Thinking",
  },
  {
    listText: "Conducting User Research",
  },
  {
    listText: "Understanding Product Life Cycle",
  },
  {
    listText: "User Segmentation & Personas",
  },
  {
    listText: "Writing User Stories",
  },
  {
    listText: "Creating Userflows, Prototypes & Wireframes",
  },
  {
    listText: "Agile Product Development",
  },
  {
    listText: "Product Roadmap",
    // listSubText:
    //   "Understanding the basics of UX/UI designConnect the product vision,strategy, and development process in line with metrics",
  },
  {
    listText: "Competitive Analysis",
  },
  {
    listText: "Product Metrics",
  },
  {
    listText: "Prioritization frameworks",
  },
  {
    listText: "Product Strategy",
  },
  {
    listText: "Minimum Viable Product",
  },
  {
    listText: "Product Launch; Go - to - market strategy",
  },
  {
    listText: "Tracking & analyzing product data",
  },
  {
    listText: "Certificate of Completion",
  },
  // { listText: "8 weeks Internship placement", }
];

export const Hybrid = [
  {
    listText: "  Everything in the advanced program online",
  },
  {
    listText:
      "In-depth training & close mentorship with an AIPMM Certified Product Manager",
  },
  {
    listText: "Small class group; only 10 people are accepted!",
  },
  { listText: "Interactive, immersive and personalised learning experience" },

  {
    listText:
      " Remarkable facility that is designed to support your learning and growth (With free internet, library, eatery and parking lot)",
  },
  {
    listText:
      " Opportunity to meet & relate with like minds on this PM career journey",
  },

  {
    listText:
      " After training support; interview prep, CV review and job recommendations**",
  },
  // {
  //   listText:
  //     "Internship placement to get real-life product management experience",
  // },
];

export const ExecutiveData = [
  {
    listText: "Product Management Fundamentals",
  },
  {
    listText: "Understanding different types of products",
  },

  {
    listText: "Market leading strategy",
  },
  {
    listText: "Building platform products",
  },
  {
    listText: "Understanding network effects",
  },
  {
    listText: "Product defensibility",
  },
  {
    listText: " Leading product teams ",
  },
  {
    listText: "Using partnership & collaboration to drive growth",
  },
  {
    listText: "Scaling products from local to international markets",
  },
  {
    listText: "Continuous product innovation for long term sustainability",
  },
  {
    listText: "Product Executive Certification",
  },
];

export const TPMData = [
  {
    listText: "Introduction to Technical Product Management",
  },
  {
    listText: "Fundamentals of APIs",
  },
  {
    listText: "API Management and Strategy",
  },
  {
    listText: "Building Effective Support Systems",
  },
  {
    listText: "Support Tools and Metrics",
  },
  {
    listText: "Using Postman and Azure to test APIs",
  },
  {
    listText: "Integration Approaches and Patterns",
  },
  {
    listText: "Integration Tools and Platforms",
  },
  {
    listText: "Deployment and deployment environments",
  },
  {
    listText: "Product Analytics",
  },
  {
    listText: "Advanced Topics and Case Studies",
  },
];

export const GrowthData = [
  {
    listText: "Introduction to Product Growth",
  },
  {
    listText: "Different types of Growth",
  },
  {
    listText:
      "Understanding Growth Terms - Gamification, Time-to-Value, Economies of Scale, Network Effects, Personalisation, Habit Forming, etc",
  },
  {
    listText: "Achieving Product Market Fit (PMF)",
  },
  {
    listText: "Growing from product market fit",
  },
  {
    listText:
      "Product Metrics AARRR (Acquisition, Activation, Retention, Referral, Revenue)",
  },
  {
    listText: "Tracking Data with Amplitude & Mixpanel",
  },
  {
    listText:
      "Rapid Testing &  Experimentation; A/B Testing & Usability Testing",
  },
  {
    listText: "Product Strategy",
  },
  {
    listText: "Product Led Growth",
  },
  {
    listText: "Collaborating with the Marketing Team",
  },
  {
    listText: "Creating & Implementing Growth Plans",
  },
  {
    listText: "Analysing Different Growth Strategies of Major Tech Companies",
  },
];
